import { render, staticRenderFns } from "./SpacesPage.vue?vue&type=template&id=22ad6110&scoped=true"
import script from "./SpacesPage.vue?vue&type=script&lang=js"
export * from "./SpacesPage.vue?vue&type=script&lang=js"
import style0 from "./SpacesPage.vue?vue&type=style&index=0&id=22ad6110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ad6110",
  null
  
)

export default component.exports